import Base from "@/controllers/base";
import http from "@/default/utils/http";
import Loading from "element-ui/lib/loading";
export default class Carrier extends Base {
  async usdotChanged(event) {
    let loading;
    let form = event.target.closest("form");
    try {
      loading = Loading.service({
        target: "#carrier-wizard",
        lock: true,
        text: "Querying information through USDOT Number",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.5)",
      });
      const number = event.target.value;
      const { data } = await http.get(
        `/api/v1/subscriptions/validate_dot?us_dot_number=${number}`,
      );
      form.querySelector("#carrier_name").value = data.name;
      form.querySelector("#carrier_mc_number").value = data.mc_number;
      form.querySelector("#carrier_phone").value = data.phone;
      form.querySelector("#carrier_address_street").value = data.address;
      form.querySelector("#carrier_address_city").value = data.city;
      form
        .querySelector("#carrier_address_state_id")
        .dispatchEvent(
          new CustomEvent("update", { detail: { value: data.state_id } }),
        );
      form.querySelector("#carrier_zip_code").value = data.zip;
      form.querySelector("#carrier_error").textContent = "";
    } catch (ex) {
      form.querySelector("#carrier_error").textContent =
        ex.response.data.errors;
      form.querySelector("#carrier_name").value = null;
      form.querySelector("#carrier_mc_number").value = null;
      form.querySelector("#carrier_phone").value = null;
      form.querySelector("#carrier_address_street").value = null;
      form.querySelector("#carrier_address_city").value = null;
      form
        .querySelector("#carrier_address_state_id")
        .dispatchEvent(new CustomEvent("update", { detail: { value: null } }));
      form.querySelector("#carrier_zip_code").value = null;
    } finally {
      loading?.close();
    }
  }
}
